import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import './SharedModel.scss';

export default class SharedModel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    let modalClass = 'shared-model';
    const { visible, detailsData, hideCancel, className, replaceCancel } = this.props;
    const { content, contentTitle, confirmText, cancelText, confirm, cancel, replaceFn, replaceCancelText } = detailsData;

    if (className) {
      modalClass = `${modalClass} ${className}`;
    }

    return (
      <Modal
        width={500}
        className={modalClass}
        // title={title}
        visible={visible}
        onCancel={(e) => {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
          cancel && cancel(e);
        }}
        closable={false}
        maskClosable={false}
        footer={null}
        // getContainer={() => {
        //   return this.props.saveRef || document.body
        // }}
      >
        <div className="contentBox">
          <h4 className="title">
            <i></i>
            {contentTitle}
          </h4>
          <p>{content}</p>
          <div className="btnBox">
            {replaceCancel && (
              <Button
                className="cancelBtn"
                onClick={(e) => {
                  replaceFn && replaceFn(e);
                }}>
                {replaceCancelText}
              </Button>
            )}
            {!hideCancel && (
              <Button
                className="cancelBtn"
                onClick={(e) => {
                  cancel && cancel(e);
                }}>
                {cancelText}
              </Button>
            )}
            <Button
              type='primary'
              className="confirmBtn"
              onClick={() => {
                confirm && confirm();
              }}>
              {confirmText}
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}
